import { Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import type { ProfileData } from "libs/codegen/property-onboarding";
import { RadioButton } from "../../commons/components/RadioButton";
import { useFormController } from "../form/useFormController";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { hostTypeMapper } from "./constant";

export const HostTypeController = () => {
    const control = useFormController<ProfileData>("hostType", {
        defaultValue: hostTypeMapper.Private,
    });
    const {
        cmsData: {
            profile: {
                hostType,
                hostTypeDescription,
                privateHost,
                privateHostDescription,
                professionalHost,
                professionalHostDescription,
            },
        },
    } = useStaticDataAtomValue();

    return (
        <VStack gap="16">
            <Typography variant="heading-default">{hostType}</Typography>
            <Typography variant="body-s" textColor="base.subtle">
                {hostTypeDescription}
            </Typography>
            <VStack gap="16" pt="8">
                <RadioButton
                    id={hostTypeMapper.Private}
                    title={privateHost}
                    description={privateHostDescription}
                    dataElementName="private-host"
                    isSelected={control.value === hostTypeMapper.Private}
                    {...control}
                />
                <RadioButton
                    id={hostTypeMapper.Professional}
                    title={professionalHost}
                    description={professionalHostDescription}
                    dataElementName="professional-host"
                    isSelected={control.value === hostTypeMapper.Professional}
                    {...control}
                />
            </VStack>
        </VStack>
    );
};
